import { Routes } from '@angular/router';
import { LoginGuard } from './core/guards/login.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  // AUTH ROUTES
  {
    path: 'auth',
    loadComponent: () =>
      import('./pages/auth/_auth-layout/auth-layout.component').then(
        (m) => m.AuthLayoutComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
        canActivate: [LoginGuard],

        data: { returnUrl: window.location.pathname },
      },
      {
        path: 'two-factor-auth',
        loadComponent: () =>
          import('./pages/auth/two-factor-auth/two-factor-auth.component').then(
            (m) => m.TwoFactorAuthComponent
          ),
      },
      {
        path: '2fa-verify',
        loadComponent: () =>
          import(
            './pages/auth/two-factor-verify/two-factor-verify.component'
          ).then((m) => m.TwoFactorVerifyComponent),
      },
      {
        path: '2fa-setup',
        loadComponent: () =>
          import(
            './pages/auth/two-factor-setup/two-factor-setup.component'
          ).then((m) => m.TwoFactorSetupComponent),
      },
      {
        path: 'email-auth',
        loadComponent: () =>
          import(
            './pages/auth/email-authenticator/email-authenticator.component'
          ).then((m) => m.EmailAuthenticatorComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent
          ),
      },
      {
        path: 'set-new-password',
        loadComponent: () =>
          import(
            './pages/auth/set-new-password/set-new-password.component'
          ).then((m) => m.SetNewPasswordComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
      {
        path: 'password-set',
        loadComponent: () =>
          import('./pages/auth/password-set/password-set.component').then(
            (m) => m.PasswordSetComponent
          ),
      },
      {
        path: 'check-email/:email',
        loadComponent: () =>
          import(
            './pages/auth/check-email-message/check-email-message.component'
          ).then((m) => m.CheckEmailMessageComponent),
      },
      {
        path: 'email-verified',
        loadComponent: () =>
          import('./pages/auth/email-verified/email-verified.component').then(
            (m) => m.EmailVerifiedComponent
          ),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },

  {
    path: 'patient-monitor',
    redirectTo: 'patient-monitor/0',
    pathMatch: 'full',
  },
  {
    path: 'patient-monitor/:page',
    canActivate: [permissionGuard],
    data: { permission: 'MONITOR' },
    loadComponent: () =>
      import(
        './pages/main/patient-monitor-page/patient-monitor-page.component'
      ).then((m) => m.PatientMonitorPageComponent),
  },
  // MAIN ROUTES
  {
    path: 'main',
    loadComponent: () =>
      import('./pages/main/_main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    children: [
      {
        path: 'dashboard',
        canActivate: [permissionGuard],
        data: { permission: 'DASHBOARD' },
        loadComponent: () =>
          import('./pages/main/dashboard-list/dashboard-list.component').then(
            (m) => m.DashboardListComponent
          ),
      },
      {
        path: 'patient-list',
        canActivate: [permissionGuard],
        data: { permission: 'PATIENT_LIST' },
        loadComponent: () =>
          import('./pages/main/patient-list/patient-list.component').then(
            (m) => m.PatientsComponent
          ),
      },
      {
        path: 'device-list',
        canActivate: [permissionGuard],
        data: { permission: 'DEVICE_LIST' },
        loadComponent: () =>
          import('./pages/main/devices/device-list/device-list.component').then(
            (m) => m.DeviceListComponent
          ),
      },
      {
        path: 'organization-devices',
        canActivate: [permissionGuard],
        data: { permission: 'ORGANIZATION_DEVICES' },
        loadComponent: () =>
          import(
            './pages/main/devices/organization-devices/organization-devices.component'
          ).then((m) => m.OrganizationDevicesComponent),
      },
      {
        path: 'patient-registration',
        canActivate: [permissionGuard],
        data: { permission: 'PATIENT_REGISTRATION' },
        loadComponent: () =>
          import(
            './pages/main/patient-registration/patient-registration.component'
          ).then((m) => m.PatientRegistrationComponent),
      },
      // {
      //   path: 'settings',
      //   loadComponent: () =>
      //     import('./pages/main/settings/settings.component').then(
      //       (m) => m.SettingsComponent
      //     ),
      // },
      {
        path: 'patient-detail/:id',
        canActivate: [permissionGuard],
        data: { permission: 'PATIENT_DETAIL' },
        loadComponent: () =>
          import('./pages/main/patient-layout/patient-layout.component').then(
            (m) => m.PatientLayoutComponent
          ),
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/main/patient-detail/patient-detail.component'
              ).then((m) => m.PatientDetailComponent),
          },
          {
            path: ':name',
            loadComponent: () =>
              import(
                './pages/main/patient-graph-detail/patient-graph-detail.component'
              ).then((m) => m.PatientGraphDetailComponent),
          },
        ],
      },
      // {
      //   path: 'patient-info/:id',
      //   canActivate: [permissionGuard],
      //   data: { permission: 'PATIENT_INFO' },
      //   loadComponent: () =>
      //     import('./pages/main/patient-info/patient-info.component').then(
      //       (m) => m.PatientInfoComponent
      //     ),
      // },
      {
        path: 'patient-update/:id',
        canActivate: [permissionGuard],
        data: { permission: 'PATIENT_INFO' },
        loadComponent: () =>
          import('./pages/main/patient-info/patient-info.component').then(
            (m) => m.PatientInfoComponent
          ),
      },
      {
        path: 'patient-create',
        canActivate: [permissionGuard],
        data: { permission: 'PATIENT_INFO' },
        loadComponent: () =>
          import('./pages/main/patient-info/patient-info.component').then(
            (m) => m.PatientInfoComponent
          ),
      },
      {
        path: 'patient-history',
        canActivate: [permissionGuard],
        data: {
          permission: 'PATIENT_HISTORY'
        },
        loadComponent: () =>
          import('./pages/main/patient-history/patient-history.component').then(
            (m) => m.PatientHistoryComponent
          ),
      },
      {
        path: 'profile',
        canActivate: [permissionGuard],
        data: { permission: 'PROFILE' },
        loadComponent: () =>
          import('./pages/main/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
      },
      {
        path: 'color-palettes',
        canActivate: [permissionGuard],
        data: { permission: 'PROFILE' },
        loadComponent: () =>
          import(
            './pages/main/color-palette-management/color-palette-management.component'
          ).then((m) => m.ColorPaletteManagementComponent),
      },
      {
        path: 'organization-info',
        canActivate: [permissionGuard],
        data: { permission: 'ORGANIZATION_INFO' },
        loadComponent: () =>
          import(
            './pages/main/organization/organization-detail/organization-detail.component'
          ).then((m) => m.OrganizationDetailComponent),
      },
      {
        path: 'organization-list',
        canActivate: [permissionGuard],
        data: { permission: 'ORGANIZATION_LIST' },
        loadComponent: () =>
          import(
            './pages/main/organization/organization-list/organization-list.component'
          ).then((m) => m.OrganizationListComponent),
      },
      {
        path: 'user-list',
        canActivate: [permissionGuard],
        data: { permission: 'USER_LIST' },
        loadComponent: () =>
          import('./pages/main/user/user.component').then(
            (m) => m.UserComponent
          ),
      },
      {
        path: 'visit-list',
        canActivate: [permissionGuard],
        data: { permission: 'VISIT_LIST' },
        loadComponent: () =>
          import('./pages/main/visit-list/visit-list.component').then(
            (m) => m.VisitListComponent
          ),
      },
      {
        path: 'calendar',
        canActivate: [permissionGuard],
        data: { permission: 'CALENDAR' },
        loadComponent: () =>
          import('./pages/main/calendar/calendar.component').then(
            (m) => m.CalendarComponent
          ),
      },
      {
        path: 'specialist-calendar',
        canActivate: [permissionGuard],
        data: { permission: 'SPECIALIST_APPOINTMENT_CALENDAR' },
        loadComponent: () =>
          import(
            './pages/main/specialist-calendar/specialist-calendar.component'
          ).then((m) => m.SpecialistCalendarComponent),
      },
      {
        path: 'laboratory-work-list',
        canActivate: [permissionGuard],
        data: { permission: 'LABORATORY_WORK_LIST' },
        loadComponent: () =>
          import(
            './pages/main/laboratory-work-list/laboratory-work-list.component'
          ).then((m) => m.LaboratoryWorkListComponent),
      },
      {
        path: 'available-schedule',
        canActivate: [permissionGuard],
        data: {
          permission: 'AVAILABILITY_SCHEDULE',
          requires: {
            isManager: true,
          },
        },
        loadComponent: () =>
          import(
            './pages/main/available-schedule/available-schedule.component'
          ).then((m) => m.AvailableScheduleComponent),
      },
      {
        path: 'route-map',
        canActivate: [permissionGuard],
        data: { permission: 'ROUTE_MAP' },
        loadComponent: () =>
          import('./pages/main/route-map/route-map.component').then(
            (m) => m.RouteMapComponent
          ),
      },
      {
        path: 'logs',
        canActivate: [permissionGuard],
        data: { permission: 'LOG' },
        loadComponent: () =>
          import('./pages/main/log/log.component').then((m) => m.LogComponent),
      },
      {
        path: 'laborator-results/:patientId',
        // canActivate: [permissionGuard],
        data: { permission: 'LABORATOR_RESULTS' },
        loadComponent: () =>
          import(
            './pages/main/laboratory-results/laboratory-results.component'
          ).then((m) => m.LaboratoryResultsComponent),
      },
      {
        path: 'radiology-results/:patientId',
        // canActivate: [permissionGuard],
        data: { permission: 'RADIOLOGY_RESULTS' },
        loadComponent: () =>
          import(
            './pages/main/radiology-results/radiology-results.component'
          ).then((m) => m.RadiologyResultsComponent),
      },
      {
        path: 'consultation-list',
        canActivate: [permissionGuard],
        data: { permission: 'CONSULTATION_LIST' },
        loadComponent: () =>
          import(
            './pages/main/consultation-list/consultation-list.component'
          ).then((m) => m.ConsultationListComponent),
      },
      {
        path: 'stock',
        canActivate: [permissionGuard],
        data: { permission: 'STOCK_MANAGEMENT' },
        loadComponent: () =>
          import('./pages/main/stock/stock-shell.component').then(
            (m) => m.StockShellComponent
          ),
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'operations',
            redirectTo: 'distribution',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/dashboard/stock-dashboard-page.component'
              ).then((m) => m.StockDashboardPageComponent),
          },
          {
            path: 'stock-list',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/list/stock-list-page.component'
              ).then((m) => m.StockListPageComponent),
          },
          {
            path: 'stock-detail/:id',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/stock-detail/stock-detail-page.component'
              ).then((m) => m.StockDetailPageComponent),
          },
          {
            path: 'new-stock-entry',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/new-entry/new-stock-entry-page.component'
              ).then((m) => m.NewStockEntryPageComponent),
          },
          {
            path: 'critical-stock',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/critical/critical-stock-page.component'
              ).then((m) => m.CriticalStockPageComponent),
          },
          {
            path: 'critical-stock/detail',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/critical-detail/critical-stock-detail-page.component'
              ).then((m) => m.CriticalStockDetailPageComponent),
          },
          {
            path: 'lot-tracking',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/lot-tracking/lot-tracking-page.component'
              ).then((m) => m.LotTrackingPageComponent),
          },
          {
            path: 'lot-tracking/detail',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/lot-tracking-detail/lot-tracking-detail-page.component'
              ).then((m) => m.LotTrackingDetailPageComponent),
          },
          {
            path: 'distribution',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/distribution/distribution-page.component'
              ).then((m) => m.DistributionPageComponent),
          },
          {
            path: 'request-management',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/request-management/request-management-page.component'
              ).then((m) => m.RequestManagementPageComponent),
          },
          {
            path: 'transfer',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/transfer/transfer-page.component'
              ).then((m) => m.TransferPageComponent),
          },
          {
            path: 'return',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/return/return-page.component'
              ).then((m) => m.ReturnPageComponent),
          },
          {
            path: 'disposal',
            loadComponent: () =>
              import(
                './pages/main/stock/pages/disposal/disposal-page.component'
              ).then((m) => m.DisposalPageComponent),
          },
        ],
      },
      {
        path: 'visit-stock',
        canActivate: [permissionGuard],
        data: { permission: 'VISIT_STOCK_OPERATIONS' },
        children: [
          {
            path: '',
            redirectTo: 'pre-visit',
            pathMatch: 'full',
          },
          {
            path: 'pre-visit',
            canActivate: [permissionGuard],
            data: {
              permission: 'VISIT_STOCK_OPERATIONS',
              requires: { isHomeCare: false },
            },
            loadComponent: () =>
              import('./pages/main/visit-stock/visit-pre-stock.component').then(
                (m) => m.VisitPreStockComponent
              ),
          },
          {
            path: 'templates',
            canActivate: [permissionGuard],
            data: {
              permission: 'VISIT_STOCK_OPERATIONS',
              requires: { isHomeCare: false },
            },
            loadComponent: () =>
              import(
                './pages/main/visit-stock/templates/visit-stock-template-page.component'
              ).then((m) => m.VisitStockTemplatePageComponent),
          },
          {
            path: 'assignments',
            canActivate: [permissionGuard],
            data: {
              permission: 'VISIT_STOCK_OPERATIONS',
              requires: { isHomeCare: false },
            },
            loadComponent: () =>
              import(
                './pages/main/visit-stock/assignments/list/visit-stock-assignment-list-page.component'
              ).then((m) => m.VisitStockAssignmentListPageComponent),
          },
          {
            path: 'assignments/:id',
            canActivate: [permissionGuard],
            data: {
              permission: 'VISIT_STOCK_OPERATIONS',
              requires: { isHomeCare: false },
            },
            loadComponent: () =>
              import(
                './pages/main/visit-stock/assignments/detail/visit-stock-assignment-detail-page.component'
              ).then((m) => m.VisitStockAssignmentDetailPageComponent),
          },
          {
            path: 'adverse-event',
            canActivate: [permissionGuard],
            data: { permission: 'VISIT_STOCK_OPERATIONS' },
            loadComponent: () =>
              import(
                './pages/main/stock/pages/adverse-events/adverse-events-shell.component'
              ).then((m) => m.AdverseEventsShellComponent),
            children: [
              {
                path: '',
                loadComponent: () =>
                  import(
                    './pages/main/stock/pages/adverse-events/active-cases/adverse-event-active-cases-page.component'
                  ).then((m) => m.AdverseEventActiveCasesPageComponent),
              },
              {
                path: 'new',
                loadComponent: () =>
                  import(
                    './pages/main/stock/pages/adverse-events/new-notification/adverse-event-new-notification-page.component'
                  ).then((m) => m.AdverseEventNewNotificationPageComponent),
              },
              {
                path: 'history',
                loadComponent: () =>
                  import(
                    './pages/main/stock/pages/adverse-events/history/adverse-event-history-page.component'
                  ).then((m) => m.AdverseEventHistoryPageComponent),
              },
              {
                path: 'detail',
                loadComponent: () =>
                  import(
                    './pages/main/stock/pages/adverse-events/detail/adverse-event-detail-page.component'
                  ).then((m) => m.AdverseEventDetailPageComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'visit-stock/usages',
        canActivate: [permissionGuard],
        data: {
          permission: 'VISIT_STOCK_OPERATIONS',
          requires: { isHomeCare: false },
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/main/visit-stock/usages/list/visit-stock-usage-list-page.component'
              ).then((m) => m.VisitStockUsageListPageComponent),
          },
          {
            path: ':id',
            loadComponent: () =>
              import(
                './pages/main/visit-stock/usages/detail/visit-stock-usage-detail-page.component'
              ).then((m) => m.VisitStockUsageDetailPageComponent),
          },
        ],
      },
      {
        path: 'visit-stock/post-visit',
        canActivate: [permissionGuard],
        data: {
          permission: 'VISIT_STOCK_OPERATIONS',
          requires: { isHomeCare: true },
        },
        loadComponent: () =>
          import(
            './pages/main/visit-stock-adjustments/visit-post-stock.component'
          ).then((m) => m.VisitPostStockComponent),
      },
      // patient-monitor-page'i buradan çıkardım
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  // ERROR ROUTES
  {
    path: 'error',
    loadComponent: () =>
      import('./pages/error/_error-layout/error-layout.component').then(
        (m) => m.ErrorLayoutComponent
      ),
    children: [
      {
        path: '404',
        loadComponent: () =>
          import('./pages/error/error-404/error-404.component').then(
            (m) => m.Error404Component
          ),
      },
      { path: '', redirectTo: '404', pathMatch: 'full' },
      { path: '**', redirectTo: '404', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];
